import { render, staticRenderFns } from "./InfoModelos.vue?vue&type=template&id=047619bf&scoped=true"
import script from "./InfoModelos.vue?vue&type=script&lang=js"
export * from "./InfoModelos.vue?vue&type=script&lang=js"
import style0 from "./InfoModelos.vue?vue&type=style&index=0&id=047619bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047619bf",
  null
  
)

export default component.exports